import { useEffect, useLayoutEffect, useState, useRef } from 'react'
import ScrollAnimation from './ScrollAnimation'
import AutoSwitch from './AutoSwitch'
import ActiveImg from './ActiveImg'
import type { Anchor } from '../index'
import education from '@/assets/images/home/education.png'
import education_active from '@/assets/images/home/education_active.png'
import finance from '@/assets/images/home/finance.png'
import finance_active from '@/assets/images/home/finance_active.png'
import government from '@/assets/images/home/government.png'
import government_active from '@/assets/images/home/government_active.png'
import industry from '@/assets/images/home/industry.png'
import industry_active from '@/assets/images/home/industry_active.png'
import land_resource from '@/assets/images/home/land_resource.png'
import land_resource_active from '@/assets/images/home/land_resource_active.png'
import medical from '@/assets/images/home/medical.png'
import medical_active from '@/assets/images/home/medical_active.png'
import traffic from '@/assets/images/home/traffic.png'
import traffic_active from '@/assets/images/home/traffic_active.png'
import check from '@/assets/images/home/check-circle.png'
import gov_bg from '@/assets/images/home/gov_bg.png'
import edu_bg from '@/assets/images/home/edu_bg.png'
import medical_bg from '@/assets/images/home/medical_bg.png'
import industry_bg from '@/assets/images/home/industry_bg.png'
import land_bg from '@/assets/images/home/land_bg.png'
import traffic_bg from '@/assets/images/home/traffic_bg.png'
import finance_bg from '@/assets/images/home/finance_bg.png'

const Industry = ({ anchorPoint }: { anchorPoint: Anchor }) => {
  const images = [
    {
      normalSrc: government,
      hoverSrc: government_active,
    },
    {
      normalSrc: education,
      hoverSrc: education_active,
    },
    {
      normalSrc: medical,
      hoverSrc: medical_active,
    },
    {
      normalSrc: industry,
      hoverSrc: industry_active,
    },
    {
      normalSrc: land_resource,
      hoverSrc: land_resource_active,
    },
    {
      normalSrc: traffic,
      hoverSrc: traffic_active,
    },
    {
      normalSrc: finance,
      hoverSrc: finance_active,
    },
  ]

  const [menuItems, setMenuItems] = useState([
    {
      id: 1,
      key: 'sol_gov',
      bg: gov_bg,
      label: '政务',
      title: (
        <ActiveImg
          normalSrc={images[0].normalSrc}
          hoverSrc={images[0].hoverSrc}
          active={false}
          alt=""
          className="w-[30px] lg:w-[100px] md:w-[80px] sm:w-[40px]"
          transitionDuration={500}
        />
      ),
      content: (
        <div className="lg:pl-10 md:pl-8 sm:pl-6 pl-0 text-white h-full w-full flex flex-col sm:justify-start lg:justify-center md:justify-center">
          <div
            style={{ fontWeight: '900' }}
            className="text-[40px] 2xl:text-[50px] 3xl:text-[60px]"
          >
            政务
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            解决方案
          </div>
          <div className="text-[14px] my-[20px]">
            基于紫东太初多模态大模型，通过智能化管理，实现城市治理的动态驾仓，提供秒级反馈，助力事件处置从经验到知识的转变。紫东太初大模型作为核心支撑，推动政府办公向高效、智能、便捷转型，全面提升城市治理水平。
          </div>
          <div className="text-[14px] flex flex-wrap justify-between gap-3">
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                一网通办方面，利用智能咨询助手、办事助手等工具，24小时不间断提供政策解答和办事指引，简化流程，提升便民利企体验。
              </span>
            </div>
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                一网协同则通过智能分析政府办公中的信息流动，加强部门间协同效应，实现从分散到聚合的优化。
              </span>
            </div>
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            应用价值
          </div>
          <div className="text-[14px] mt-[20px]">
            依托紫东太初大模型，实现一网统管、一网通办、一网协同，显著提升政府办公效率与服务质量，优化城市治理，增强公众满意度。通过智能化手段促进政府内部协同，助力决策科学高效，为构建智慧型政府奠定坚实基础，具有重要应用价值。
          </div>
        </div>
      ),
    },
    {
      id: 2,
      key: 'sol_edu',
      bg: edu_bg,
      label: '教育',
      title: (
        <ActiveImg
          normalSrc={images[1].normalSrc}
          hoverSrc={images[1].hoverSrc}
          active={false}
          alt=""
          className="w-[30px] lg:w-[120px] md:w-[100px] sm:w-[50px]"
          transitionDuration={500}
        />
      ),
      content: (
        <div className="lg:pl-10 md:pl-8 sm:pl-6 pl-0 text-white h-full w-full flex flex-col sm:justify-start lg:justify-center md:justify-center">
          <div
            style={{ fontWeight: '900' }}
            className="text-[40px] 2xl:text-[50px] 3xl:text-[60px]"
          >
            教育
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            解决方案
          </div>
          <div className="text-[14px] my-[20px]">
            基于紫东太初多模态大模型、知识图谱等有机结合而成“数据+知识”双引擎，打造教与学的新范式。
          </div>
          <div className="text-[14px] flex justify-between flex-wrap gap-3">
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                AI学习助手通过智能答疑、学科陪练等为学生提供个性化、高效的学习支持。AI分析通过课堂教学的精细化评价促进教学质量提升。
              </span>
            </div>
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                AI助教通过数字人课程、课堂助手、智能出题、智能批改等，显著提升教室的备课和授课效率。
              </span>
            </div>
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            应用价值
          </div>
          <div className="text-[14px] my-[20px]">
            基于紫东太初多模态大模型教育解决方案，从教学到学习再到管理，全面提升教育的效率和质量，推动教育资源的公平普及，引领新的教学模式和学习范式，打造教育行业智能化升级的新生态。
          </div>
        </div>
      ),
    },
    {
      id: 3,
      key: 'sol_med',
      bg: medical_bg,
      label: '医疗',
      title: (
        <ActiveImg
          normalSrc={images[2].normalSrc}
          hoverSrc={images[2].hoverSrc}
          active={false}
          alt=""
          className="w-[30px] lg:w-[120px] md:w-[100px] sm:w-[50px]"
          transitionDuration={500}
        />
      ),
      content: (
        <div className="lg:pl-10 md:pl-8 sm:pl-6 pl-0 text-white h-full w-full flex flex-col sm:justify-start lg:justify-center md:justify-center">
          <div
            style={{ fontWeight: '900' }}
            className="text-[40px] 2xl:text-[50px] 3xl:text-[60px]"
          >
            医疗
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            解决方案
          </div>
          <div className="text-[14px] my-[20px]">
            基于紫东太初多模态大模型构建医疗行业大模型，整合多源医疗数据，挖掘其中关键信息，辅助医生精准诊断疾病，降低误诊率。
          </div>
          <div className="text-[14px] flex justify-between flex-wrap gap-3">
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                在治疗方面，依据患者个体差异生成优化方案，提高疗效。对于医疗影像，可快速准确解读，发现细微病灶。还能通过智能交互，为患者提供
                24 小时在线咨询服务，缓解医护压力。
              </span>
            </div>
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                在科研领域，助力药物研发和医学研究，分析实验数据，探索新的治疗靶点，推动医疗行业智能化升级与高效发展。
              </span>
            </div>
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            应用价值
          </div>
          <div className="text-[14px] my-[20px]">
            紫东太初多模态大模型为医疗行业注入新动力。能深度分析海量数据，辅助医生精准诊断，生成个性化治疗方案。提升医疗效率，优化资源配置，助力科研创新，还可为患者提供贴心咨询服务，全面提升医疗服务质量与体验，开启智慧医疗新篇章。
          </div>
        </div>
      ),
    },
    {
      id: 4,
      key: 'prd_indu',
      bg: industry_bg,
      label: '工业',
      title: (
        <ActiveImg
          normalSrc={images[3].normalSrc}
          hoverSrc={images[3].hoverSrc}
          active={false}
          alt=""
          className="w-[30px] lg:w-[120px] md:w-[100px] sm:w-[50px]"
          transitionDuration={500}
        />
      ),
      content: (
        <div className="lg:pl-10 md:pl-8 sm:pl-6 pl-0 text-white h-full w-full flex flex-col sm:justify-start lg:justify-center md:justify-center">
          <div
            style={{ fontWeight: '900' }}
            className="text-[40px] 2xl:text-[50px] 3xl:text-[60px]"
          >
            工业
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            解决方案
          </div>
          <div className="text-[14px] mt-[20px]">
            大模型技术为工业领域提供了创新的解决方案。通过与现有工业系统数据的深度整合，大模型技术可在工业知识管理、安全生产、设备运维、智能应用开发、智能办公以及智能客服等多个应用场景发挥作用。这些应用不仅优化工业流程，还显著提升工业领域的质量和效率，实现了提质增效的目标，这些进步共同推动工业企业在智能化和高效化道路上的快速发展。
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            应用价值
          </div>
          <div className="text-[14px] flex flex-wrap lg:flex-nowrap gap-3 mt-[20px]">
            <div className="min-w-[250px] w-[32%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <div>
                <div className="mb-[5px]">提升生产效率与质量</div>
                <span className="text-[12px]">
                  优化生产流程和精准预测设备故障，提升企业的生产效率和产品质量，同时有效降低生产成本。
                </span>
              </div>
            </div>
            <div className="min-w-[250px] w-[30%] lg:w-[280px] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <div>
                <div className="mb-[5px]">增强智能化与市场竞争力</div>
                <span className="text-[12px]">
                  增强智能化水平，提升市场竞争力，使其在激烈的市场竞争中占据有利地位。
                </span>
              </div>
            </div>
            <div className="min-w-[250px] w-[30%] lg:w-[280px] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <div>
                <div className="mb-[5px]">促进数据整合与决策支持</div>
                <span className="text-[12px]">
                  促进数据的全面整合和深度利用，为决策提供了更加精准和可靠的数据支持，推动向智能化、高效化方向发展。
                </span>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: 5,
      key: 'prd_land',
      bg: land_bg,
      label: '国土资源',
      title: (
        <ActiveImg
          normalSrc={images[4].normalSrc}
          hoverSrc={images[4].hoverSrc}
          active={false}
          alt=""
          className="w-[30px] lg:w-[120px] md:w-[100px] sm:w-[50px]"
          transitionDuration={500}
        />
      ),
      content: (
        <div className="lg:pl-10 md:pl-8 sm:pl-6 pl-0 text-white h-full w-full flex flex-col sm:justify-start lg:justify-center md:justify-center">
          <div
            style={{ fontWeight: '900' }}
            className="text-[40px] 2xl:text-[50px] 3xl:text-[60px]"
          >
            国土资源
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            解决方案
          </div>
          <div className="text-[14px] my-[20px]">
            基于紫东太初多模态大模型打造的国土资源监管解决方案，利用其对多源数据的强大处理能力，融合卫星影像、地理信息等数据，实现更精准实时的土地监测与变化检测。
          </div>
          <div className="text-[14px] flex justify-between flex-wrap gap-3">
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                辅助执法决策，通过分析历史案例与法规，为执法提供准确建议。
              </span>
            </div>
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                打破信息孤岛，促进数据共享与协同工作，同时提升公众参与度，为公众反馈提供智能处理渠道。
              </span>
            </div>
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            应用价值
          </div>
          <div className="text-[14px] my-[20px]">
            紫东太初多模态大模型国土资源监管方案能高效融合多源数据实现精准实时监测，为执法提供科学决策依据，打破信息孤岛促进协同工作，提高公众参与度增强国土保护意识，推动行业智能化转型，助力可持续发展。
          </div>
        </div>
      ),
    },
    {
      id: 6,
      key: 'prd_traffic',
      bg: traffic_bg,
      label: '交通',
      title: (
        <ActiveImg
          normalSrc={images[5].normalSrc}
          hoverSrc={images[5].hoverSrc}
          active={false}
          alt=""
          className="w-[30px] lg:w-[120px] md:w-[100px] sm:w-[50px]"
          transitionDuration={500}
        />
      ),
      content: (
        <div className="lg:pl-10 md:pl-8 sm:pl-6 pl-0 text-white h-full w-full flex flex-col sm:justify-start lg:justify-center md:justify-center">
          <div
            style={{ fontWeight: '900' }}
            className="text-[40px] 2xl:text-[50px] 3xl:text-[60px]"
          >
            交通
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            解决方案
          </div>
          <div className="text-[14px] my-[20px]">
            针对交通领域的痛点，大模型技术的应用提供了创新的解决方案。
          </div>
          <div className="text-[14px] flex flex-wrap lg:flex-nowrap gap-3">
            <div className="w-full min-w-[250px] w-[32%] p-3 bg-[#cccccc20] flex items-center justify-start gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                通过结合自然语言理解和交通系统模型，实现多模态数据输入和复杂任务处理，提升交通感知、认知和预知能力，实现智能交通管理。
              </span>
            </div>
            <div className="w-full min-w-[250px] w-[30%] p-3 bg-[#cccccc20] flex items-center justify-start gap-3">
              <img className="w-[20px]" src={check} />
              <span>通过深度学习算法优化交通信号灯控制，减少交通拥堵</span>
            </div>
            <div className="w-full min-w-[250px] w-[30%] p-3 bg-[#cccccc20] flex items-center justify-start gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                建立交通事故预测模型，提前预警潜在风险；以及结合物联网技术对交通基础设施进行实时监测和维护。
              </span>
            </div>
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            应用价值
          </div>
          <div className="text-[14px] flex flex-wrap sm:flex-nowrap gap-2 my-[8px]">
            <div className="w-full min-w-[200px] lg:max-w-[400px]">
              <div className="mb-[5px]">缓解交通拥堵：</div>
              <span className="text-[12px]">
                通过智能交通管理，优化交通流，减少拥堵现象，提高道路通行效率。
              </span>
            </div>
            <div className="w-full min-w-[200px] lg:max-w-[400px]">
              <div className="mb-[5px]">降低事故发生率：</div>
              <span className="text-[12px]">
                提前预测交通事故，采取预防措施，保障人民群众的生命财产安全。
              </span>
            </div>
          </div>
          <div className="text-[14px] flex flex-wrap sm:flex-nowrap gap-2 my-[8px]">
            <div className="w-full min-w-[200px] lg:max-w-[400px]">
              <div className="mb-[5px]">提升出行体验：</div>
              <span className="text-[12px]">
                缩短出行时间，提高出行舒适度，增强人民群众的满意度。
              </span>
            </div>
            <div className="w-full min-w-[200px] lg:max-w-[400px]">
              <div className="mb-[5px]">优化基础设施管理：</div>
              <span className="text-[12px]">
                实时监测交通基础设施，降低维护成本，延长使用寿命。
              </span>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: 7,
      key: 'prd_finance',
      bg: finance_bg,
      label: '金融',
      title: (
        <ActiveImg
          normalSrc={images[6].normalSrc}
          hoverSrc={images[6].hoverSrc}
          active={false}
          alt=""
          className="w-[30px] lg:w-[120px] md:w-[100px] sm:w-[50px]"
          transitionDuration={500}
        />
      ),
      content: (
        <div className="lg:pl-10 md:pl-8 sm:pl-6 pl-0 text-white h-full w-full flex flex-col sm:justify-start lg:justify-center md:justify-center">
          <div
            style={{ fontWeight: '900' }}
            className="text-[40px] 2xl:text-[50px] 3xl:text-[60px]"
          >
            金融
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            解决方案
          </div>
          <div className="text-[14px] my-[20px]">
            基于紫东太初多模态大模型打造金融行业创新解决方案。
          </div>
          <div className="text-[14px] flex justify-between flex-wrap gap-3">
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                在智能投顾领域，能依据海量数据与用户画像，精准定制投资策略，降低投资风险。于风险管理方面，通过深度分析多源数据，快速识别潜在风险点并预警。
              </span>
            </div>
            <div className="min-w-[300px] w-[49%] p-5 bg-[#cccccc20] flex-center gap-3">
              <img className="w-[20px]" src={check} />
              <span>
                客户服务中，大模型可实现智能交互， 7×24
                小时高效解答客户咨询，提升服务满意度。同时助力金融机构进行市场趋势预测，优化产品设计与营销方案，推动金融业务智能化升级与高效运营。
              </span>
            </div>
          </div>
          <div
            style={{ fontWeight: '700' }}
            className="text-[24px] 2xl:text-[28px] 3xl:text-[32px] mt-[30px] xl:mt-[35px] 2xl:mt-[40px] 3xl:mt-[50px]"
          >
            应用价值
          </div>
          <div className="text-[14px] my-[20px]">
            基于紫东太初多模态大模型打造的金融行业解决方案，通过精准预测、风险防控、智能决策和个性化服务，显著提升金融服务的效率和质量，大力推动金融创新，增强市场竞争力，全面驱动金融行业数智化转型升级。
          </div>
        </div>
      ),
    },
  ])

  const getInitIndex = () => {
    const index = menuItems.findIndex(item => item.key === anchorPoint.anchor)
    return index > -1 ? index : 0
  }

  const [startActiveIndex, setStartActiveIndex] = useState(getInitIndex())
  const [currentBg, setCurrentBg] = useState('')
  const [nextBg, setNextBg] = useState('')
  const [isTransitioning, setIsTransitioning] = useState(false)
  const bgRef = useRef<HTMLImageElement>(null)

  useLayoutEffect(() => {
    // 滚动页面到顶部
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])
  // 预加载所有背景图片
  useEffect(() => {
    // 设置初始背景
    setCurrentBg(menuItems[startActiveIndex].bg)
  }, [])

  useEffect(() => {
    if (anchorPoint) {
      menuItems.forEach((item, i) => {
        if (item.key === anchorPoint.anchor) {
          setStartActiveIndex(i)
        }
      })
    }
  }, [anchorPoint])

  const handleActiveChange = (index: number) => {
    if (isTransitioning) return

    const targetBg = menuItems[index].bg
    if (targetBg === currentBg) return

    setNextBg(targetBg)
    setIsTransitioning(true)

    // 确保新图片已加载
    const img = new Image()
    img.src = targetBg
    img.onload = () => {
      // 使用requestAnimationFrame保证流畅性
      requestAnimationFrame(() => {
        setCurrentBg(targetBg)
        setIsTransitioning(false)
      })
    }

    const newMenuItems = menuItems.map((item, i) => {
      return {
        ...item,
        title: (
          <ActiveImg
            normalSrc={images[i].normalSrc}
            hoverSrc={images[i].hoverSrc}
            active={index === i}
            alt=""
            content={
              <div
                className={`${index === i ? 'text-white' : 'text-gray-500'} text-[4px] lg:text-[16px] md:text-[12px] sm:text-[10px] absolute bottom-1 left-1 z-10`}
              >
                {item.label}
              </div>
            }
            className="w-[30px] lg:w-[110px] md:w-[90px] sm:w-[40px] sm:rounded-[5px] rounded-[3px] border border-[#635e9b]"
            activeClassName="shadow-[0_50px_60px_rgba(93,141,235,0.8)] border-2 border-[#6b9fff]"
            transitionDuration={500}
          />
        ),
      }
    })
    setMenuItems(newMenuItems)
  }

  return (
    <div className="bg-overlay-dark w-full h-full overflow-hidden relative">
      {/* 背景图片容器 */}
      <div className="absolute inset-0 transition-opacity duration-500">
        <img
          ref={bgRef}
          src={currentBg}
          alt="background"
          className="w-full h-full object-cover object-center absolute inset-0 transition-opacity duration-500"
          style={{ opacity: isTransitioning ? 0 : 1 }}
        />
        {isTransitioning && (
          <img
            src={nextBg}
            alt="next background"
            className="w-full h-full object-cover object-center absolute inset-0 transition-opacity duration-500"
            style={{ opacity: isTransitioning ? 1 : 0 }}
          />
        )}
      </div>

      {/* 内容容器 */}
      <ScrollAnimation>
        <div className="relative z-10">
          <div
            className={
              'max-w-[1500px] min-h-[700px] xl:h-[calc(100vh-54px)] h-auto sm:px-40 pt-20 mx-auto flex flex-col justify-center items-center'
            }
          >
            <AutoSwitch
              auto={false}
              items={menuItems}
              interval={2000}
              startActiveIndex={startActiveIndex}
              activeChange={handleActiveChange}
            />
          </div>
        </div>
      </ScrollAnimation>
    </div>
  )
}

export default Industry
